import React from "react"
import HorizontalField from "../HorizontalField/HorizontalField"
import {UnitOrBankUserOnly} from "../../containers/PermissionedUser/PermissionedUser"
import {OrgName} from "../OrgName/OrgName"
import {Resource} from "../../resources/common"
import moment from "moment"
import {DecisionMethodType, ProductType} from "../../resources/productApplication"
import {useNavigate} from "react-router-dom"

interface ProductApplicationAdditionalInfoProps {
	requestedProduct: ProductType
	decisionMethod?: DecisionMethodType
	preApprovedEvaluatedAt?: Date
	orgId: string
	included?: Resource[]
	productApplicationPreApprovedLink?: {
		link: string
		text: string
	}
}

export default function ProductApplicationAdditionalInfo({
	requestedProduct,
	decisionMethod,
	preApprovedEvaluatedAt,
	orgId,
	included,
	productApplicationPreApprovedLink,
}: ProductApplicationAdditionalInfoProps) {
	const navigate = useNavigate()

	return (
		<div className="card product-application-additional-info">
			<div className="card-header">
				<p className="card-header-title">Additional Information</p>
			</div>
			<div className="card-content">
				<HorizontalField label="Requested Product">
					<span className="tag is-light country-tag">{requestedProduct}</span>
				</HorizontalField>
				{decisionMethod && (
					<HorizontalField label="Decision Method">
						<input type="text" readOnly value={decisionMethod} className="input is-static" />
					</HorizontalField>
				)}
				{preApprovedEvaluatedAt && (
					<HorizontalField label="Approved At">
						<input
							type="text"
							readOnly
							value={moment(preApprovedEvaluatedAt).format("L LT")}
							className="input is-static"
						/>
					</HorizontalField>
				)}
				<UnitOrBankUserOnly>
					<HorizontalField label="Org">
						<OrgName orgId={orgId} included={included} element={"span"} />
					</HorizontalField>
				</UnitOrBankUserOnly>
				{productApplicationPreApprovedLink && (
					<HorizontalField label="Previously CIP">
						<a
							href={productApplicationPreApprovedLink.link}
							className="previously-cip-link input is-static"
							onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								navigate(productApplicationPreApprovedLink.link)
							}}
						>
							{productApplicationPreApprovedLink.text}
						</a>
					</HorizontalField>
				)}
			</div>
		</div>
	)
}
